
import sty from './ap.module.scss';
import { useEffect, useState } from 'react';

export default function Button1({displayId,title,onClick,disabled=false}){
	//,loading=false, setLoading
	//loading

  const [loading, setLoading] = useState(false);

	return (<button className={sty.nextb} disabled={disabled} type={displayId!=3?'button':'submit'} 
			onClick={()=>{
				setLoading(true);
				setTimeout(()=>{
				setLoading(false);
onClick();
				},1500);
			}}>
{loading?<div className={sty.loader}></div>:<>{title}</>}
			</button>);
}
